import axios from 'axios';
import {
  AI_PROMPT_BUILDER_FETCH_FIGMA_IMAGE_BEGIN,
  AI_PROMPT_BUILDER_FETCH_FIGMA_IMAGE_SUCCESS,
  AI_PROMPT_BUILDER_FETCH_FIGMA_IMAGE_FAILURE,
  AI_PROMPT_BUILDER_FETCH_FIGMA_IMAGE_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function fetchFigmaImage(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: AI_PROMPT_BUILDER_FETCH_FIGMA_IMAGE_BEGIN,
    });

    // Return a promise so that you could control UI flow without states in the store.
    // For example: after submit a form, you need to redirect the page to another when succeeds or show some errors message if fails.
    // It's hard to use state to manage it, but returning a promise allows you to easily achieve it.
    // e.g.: handleSubmit() { this.props.actions.submitForm(data).then(()=> {}).catch(() => {}); }
    const promise = new Promise((resolve, reject) => {
      // doRequest is a placeholder Promise. You should replace it with your own logic.
      // See the real-word example at:  https://github.com/supnate/rekit/blob/master/src/features/home/redux/fetchRedditReactjsList.js
      // args.error here is only for test coverage purpose.
      const { projectId, version } = args;
      const header = builderSurfaceJsonContentHeader(projectId);
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/figma/get-figma-Image`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: AI_PROMPT_BUILDER_FETCH_FIGMA_IMAGE_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: AI_PROMPT_BUILDER_FETCH_FIGMA_IMAGE_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissFetchFigmaImageError() {
  return {
    type: AI_PROMPT_BUILDER_FETCH_FIGMA_IMAGE_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case AI_PROMPT_BUILDER_FETCH_FIGMA_IMAGE_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchFigmaImagePending: true,
        fetchFigmaImageError: null,
      };

    case AI_PROMPT_BUILDER_FETCH_FIGMA_IMAGE_SUCCESS:
      // The request is success
      return {
        ...state,
        fetchFigmaImagePending: false,
        fetchFigmaImageError: null,
      };

    case AI_PROMPT_BUILDER_FETCH_FIGMA_IMAGE_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchFigmaImagePending: false,
        fetchFigmaImageError: action.data.error,
      };

    case AI_PROMPT_BUILDER_FETCH_FIGMA_IMAGE_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchFigmaImageError: null,
      };

    default:
      return state;
  }
}
